/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Upload_UnlimitedInputs */

const en_mobile_benefits_upload_unlimited = /** @type {(inputs: Mobile_Benefits_Upload_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload unlimited papers & books`)
};

const es_mobile_benefits_upload_unlimited = /** @type {(inputs: Mobile_Benefits_Upload_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube artículos y libros ilimitados`)
};

/**
* | output |
* | --- |
* | "Upload unlimited papers & books" |
*
* @param {Mobile_Benefits_Upload_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_upload_unlimited = /** @type {((inputs?: Mobile_Benefits_Upload_UnlimitedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Upload_UnlimitedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_upload_unlimited(inputs)
	return en_mobile_benefits_upload_unlimited(inputs)
});